import { gql } from '@apollo/client';

export const GET_CATEGORIES = gql`
  query GETCATEGORIES {
    textFor {
      pageTitle: pair(pairKey: "siteMap") {...textPair}
    }
    categoriesList {
      ...CategoryFields
      ...CategoriesRecursive
    }
  }

  fragment CategoryFields on Category {
    categoryId
    name
    url
    brand    
  }

  fragment CategoriesRecursive on Category {
    subCategories {
      ...CategoryFields
      subCategories {
        ...CategoryFields
        subCategories {
          ...CategoryFields
        }
      }
    }
  }

  fragment textPair on TextPair {
    key
    value
  }
`;

export const GET_SITEMAP_HELPFUL_LINKS = gql`
  query GETSITEMAPHELPFULLINKS{
    footer(isDesktop: true) {
      utilityLinks {
        title
        url
        external
        id
      }
      aboutLinks {
        title
        url
        external
        id
      }
      helpLinks {
        title
        url
        external
        id
      }
      iconLinks {
        title
        url
        external
        id
      }
    }
  }
`;
